import { Row, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import usePublicPageSeo from "../../../hooks/global/usePublicPageSeo";
import { blogArticles } from "../../../data/blog-articles";
import HomePageNavbarComponent from "../../../components/HomePageNavbarComponent/HomePageNavbarComponent";
import "./HomeBlogComponent.less";

const HomeBlogComponent = () => {
  const { t } = useTranslation();
  usePublicPageSeo({ path: "/blogs" });
  return (
    <div className="blog-wrapper">
      <div className="blog-layout">
        <HomePageNavbarComponent />
        <Row className="home-blog-row">
          <Typography.Text className="home-blog-title">
            <span>Twizz</span>Blog
          </Typography.Text>

          <Typography.Text className="home-blog-subtitle">{t("blog-subtitle")}</Typography.Text>

          <Row className="home-blog-cards-row">
            {blogArticles.map((article) => (
              <Link key={article.id} to={`/blogs/${article.slug}`} className="blog-card-link">
                <div className="blog-card">
                  <div className="blog-card-category">{article.category}</div>
                  <Typography.Text className="blog-card-title">{article.title}</Typography.Text>
                  <Typography.Text className="blog-card-description">{article.metaDescription}</Typography.Text>
                </div>
              </Link>
            ))}
          </Row>
        </Row>
      </div>
      {/* SEO: Link for crawlers */}
      <details>
        <summary style={{ listStyle: "none" }}></summary>
        <a href="/profiles">Creator Profiles</a>
      </details>
    </div>
  );
};

export default HomeBlogComponent;
